import React, { useContext, useEffect, useState } from "react";
import { injectIntl } from "react-intl";

import { useIsVisible } from "../../Base/Hooks/IsVisible";
import { useDoActions } from "../../Base/Hooks/doActions";
import { FixtureDetailsContext } from "../../../Config/FixtureDetails";
import { allowedValues } from "./MiniLocationConfig";
import PositionHelper from "../../Base/Utilities/PositionHelper";

import "./MiniLocation.scss";

const MiniLocation = (props) => {
  const { panel, updateState, currentState, intl } = props;
  const { formatMessage } = intl;
  const [isVisible, isEnabled] = useIsVisible(panel, props);
  const { sport } = useContext(FixtureDetailsContext);
  const [doAction, setDoAction] = useState(false);
  const [events, setEvents] = useState();
  const [position, setPosition] = useState();
  const [positionSelected, setPositionSelected] = useState(false);
  const [actionsDone] = useDoActions(panel, props, doAction);

  useEffect(() => {
    if (actionsDone) {
      setDoAction(false);
    }
    // eslint-disable-next-line
  }, [actionsDone]);

  useEffect(() => {
    setEvents(currentState.events);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const posX = currentState.events?.edit?.x ?? "0";
    const posY = currentState.events?.edit?.y ?? "0";
    setPosition({ x: posX, y: posY });
  }, []);

  useEffect(() => {
    if (position && events && positionSelected && !panel.options?.needConfirmation) {
      handleDone();
    }
    // eslint-disable-next-line
  }, [position]);

  function checkAllowedValues(event) {
    Object.keys(event.options).forEach((option) => {
      if (!allowedValues[event.eventType].options.includes(option)) {
        delete event.options[option];
      }
    });
    if (!allowedValues[event.eventType].subTypes.includes(event.subType)) {
      delete event.subType;
    }
    return event;
  }

  function getPos(e) {
    let posX = parseFloat(((e.nativeEvent.offsetX / e.target.offsetWidth) * 100).toFixed(2));
    let posY = parseFloat(((e.nativeEvent.offsetY / e.target.offsetHeight) * 100).toFixed(2));
    setPositionSelected(true);
    setPosition({ x: posX, y: posY });
  }

  function handleDone() {
    let tempEvents = events;
    tempEvents.edit.x = position.x;
    tempEvents.edit.y = position.y;
    if (panel.options?.positionBasedRegion) {
      const entityId = tempEvents.edit.entityId;
      const teamNo = currentState.entities.findIndex((ent) => ent.entityId === entityId);
      const point = PositionHelper.getPoint(position.x, position.y, sport);
      const eventRegion =
        teamNo === 0
          ? point === "P1" || point === "C1"
            ? "2pt"
            : "3pt"
          : point === "P2" || point === "C2"
            ? "2pt"
            : "3pt";
      tempEvents.edit.eventType = eventRegion;
    } else {
      tempEvents.edit.eventType = events.edit.eventType === "2pt" ? "3pt" : "2pt";
    }
    tempEvents.edit = checkAllowedValues(tempEvents.edit);

    updateState("events", tempEvents);
    setDoAction(true);
  }

  return (
    <React.Fragment>
      {isVisible && (
        <>
          <div className={panel.layout + " mini-location enabled-" + isEnabled} onClick={(e) => getPos(e)}>
            <div
              className="mini-location-marker"
              style={{
                top: position.y - 1.5 + "%",
                left: position.x - 1.5 + "%",
              }}
            ></div>
          </div>
          {panel.options?.needConfirmation && (
            <div className={"enabled-" + isEnabled + " mini-location-btn-done"} onClick={handleDone}>
              {formatMessage({
                id: "mini-location.save",
                defaultMessage: "Save new location",
              })}
            </div>
          )}
        </>
      )}
    </React.Fragment>
  );
};

export default injectIntl(MiniLocation);
